var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._g(_vm._b({staticClass:"theme-input",attrs:{"value":_vm.value,"items":_vm.items,"item-text":_vm.itemText,"item-value":_vm.itemValue,"loading":_vm.loading,"disabled":_vm.disabled,"clearable":_vm.clearable,"multiple":_vm.multiple,"chips":_vm.chips,"menu-props":{
    contentClass: 'theme-select-menu',
    transition: 'slide-y-transition',
    offsetY: true,
    maxHeight: 300,
  }}},'v-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }